import CatchError from '@/components/system/CacthError';
// export const runtime = 'experimental-edge';

export const TGEarn = () => {
  return (
    <div>
      <h1>Earn Coming Soon...</h1>
    </div>
  );
};
export default CatchError(TGEarn);
